<template>
	<div>
		<triangle-image
			:title="title"
			:backgroundStyle="backgroundStyle">
		</triangle-image>

		<div class="container">
			<component :is="template">
				<section id="slider" v-if='recipes' slot="slider">
					<slick>
						<template slot="slides">
							<div class='recipe' v-for="(item, index) in recipes" :key="index">
								<a :href="'/ricetta/' + item.url"><img :src="item.images.big" :alt='item.title'></a>
								<div class="recipe-name">{{ item.title }}</div>
							</div>
						</template>
					</slick>
				</section>

				<section slot="button">
					<div class="center">
						<router-link :to="{ name: 'flow-new' }">
							<CTA
								:content="user ? 'Vai alle ricette' : 'Scegli il tuo piano'"
								isArrow
							/>
						</router-link>
					</div>
				</section>
			</component>
		</div>
	</div>
</template>

<script>
import TriangleImage from '../TriangleImage'

import Nutracentis from './Nutracentis'
import Lenticchie from './Lenticchie'
import Legumotti from './Legumotti'
import Spaghetti from './Spaghetti'
import Perugina from './Perugina'
import CTA from '../Elements/CTA'

import Slick from '../Slick'
import { goSlick } from '../../assets/js/slick'

import { RecipeApi } from '../../api/RecipeApi'
import { Recipe } from '../../core/Recipe'

export default {
	components: {
		'triangle-image': TriangleImage,
		'slick': Slick,
		'lenticchie': Lenticchie,
		'legumotti': Legumotti,
		'perugina': Perugina,
		'spaghetti': Spaghetti,
		'nutracentis': Nutracentis,
		CTA
	},

	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		},
		template: {
			type: String,
			default: null
		}
	},

	data () {
		return {
			recipes: null,

			slider: {
				legumotti: [399, 410, 431, 454, 455, 456],
				lenticchie: [405, 441, 423],
				perugina: [380, 452, 450, 449, 369, 353, 351],
				spaghetti: [465, 464, 462, 461, 460],
				nutracentis: [589, 588, 568, 567, 566]
			},

			background: {
				legumotti: require('../../assets/img/covers/legumotti.jpg'),
				lenticchie: require('../../assets/img/covers/lenticchie.jpg'),
				perugina: require('../../assets/img/covers/GranBlocco_Perugina.jpg'),
				spaghetti: require('../../assets/img/covers/spaghetti_di_verdura_misti.jpg'),
				nutracentis: require('../../assets/img/covers/nutracentis-pasta.jpg')
			}
		}
	},

	methods: {
		load () {
			var promises = []

			this.slider[this.template].forEach(id => {
				promises.push(new Promise((resolve, reject) =>
					this.loadRecipe(id).then(_ => {
						resolve(_)
					})
				))
			})

			return Promise.all(promises)
		},

		loadRecipe (id) {
			this.recipes = []
			var rm = new RecipeApi()
			return rm.recipe(id).then(response => {
				var recipe = new Recipe(response.body.data.resource)
				this.recipes.push(recipe)
			})
		}
	},

	computed: {
		title () {
			return this.$t('components.special_ingredient.' + this.template + '.title')
		},

		backgroundStyle () {
			return {
				backgroundImage: 'url(' + this.background[this.template] + ')',
				backgroundPosition: 'center 30%'
			}
		}
	},

	mounted () {
		this.load().then(_ => {
			goSlick()
		})
	}
}

</script>
